import { CheckboxProps } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Favorite from "@mui/icons-material/Favorite";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import * as React from "react";

const Text = withStyles({
  root: {
    color: "#ffffff",
    fontSize: "14px",
  },
})(Typography);

const CustomButton = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "5px",
}));

const label = { inputProps: { "aria-label": "Checkbox demo" } };

interface LikeButtonProps extends CheckboxProps {
  text: string,
}

const LikeButton: React.FC<LikeButtonProps> = ({ text, ...props }) => {
  return (
    <CustomButton>
      <Checkbox
        {...label}
        icon={<FavoriteBorderOutlinedIcon style={{ color: "#c1c1c1" }} />}
        checkedIcon={<Favorite style={{ color: "#ddb930" }} />}
        style={{ padding: "unset", fontSize: "20px", paddingBottom: "0px !important" }}
        {...props}
      />
      <Text>{text}</Text>
    </CustomButton>
  );
}

export default LikeButton;
